import React from "react";

const RenderAmount = ({
  value: x,
  style,
  minimumFractionDigits = 0,
  maximumFractionDigits = 2,
}) => (
  <div className="numeric" style={style}>
    {x !== null && x !== undefined && !isNaN(x)
      ? "₹" +
        x.toLocaleString(undefined, {
          minimumFractionDigits,
          maximumFractionDigits,
        })
      : ""}
  </div>
);

export const RenderDenomination = ({ denominations }) => {
  if (!denominations || typeof denominations !== "object") return "";

  const ORDER = [2000, 500, 200, 100, 50, 20, 10, 5, 2, 1];

  return ORDER.filter((key) => denominations[key] > 0)
    .map((key) => {
      if (key === 1) {
        return `Manual × ${denominations[key]}`;
      }
      return `₹${key} × ${denominations[key]}`;
    })
    .join(", ");
};

export default RenderAmount;
